import cls from 'classnames';
import React from 'react';
import { RicosContext } from 'ricos-context';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';

import { CheckIcon, LoaderIcon, NonEditableIcon } from '../../assets/icons';
import {
  POLLS_ANSWER_IMAGE,
  POLLS_ANSWER_TEXT_INPUT,
  POLLS_ITEM_PERCENTAGE_PREVIEW,
} from '../../dataHooks';
import { ImageUpload } from '../image-upload';
import { TextField } from '../text-field';
import styles from './option.scss';
import { PollOptionBase } from './PollOptionBase';
import { RemoveOption } from './RemoveOption';

export class PollListOption extends PollOptionBase {
  static propTypes = PollOptionBase.propTypes;

  static contextType = RicosContext;

  getCustomStyle() {
    const { design } = this.props;

    const borderRadius = parseInt(design.options?.borderRadius);

    return {
      input: {
        borderRadius,
      },
      image: {
        borderRadius,
      },
    };
  }

  renderViewMode() {
    const { design, option, showResults, dark, t } = this.props;
    const { loading, checked } = this.state;

    const style = this.getCustomStyle();

    return (
      <div
        className={cls(styles.option, styles.list, styles.cta, {
          [styles.with_image]: this.isImageEnabled() ? option.image?.src.url : null,
          [styles.user_choice]: this.isUserChoice(),
          [styles.dark]: dark,
        })}
        style={design.option}
        onClick={this.handleVoteClick}
        onKeyPress={this.handleVoteClick}
        aria-label={
          checked
            ? t('Poll_Viewer_Option_AriaLabel_Checked')
            : t('Poll_Viewer_Option_AriaLabel_Unchecked')
        }
        tabIndex={this.context.tabIndex}
        role="button"
      >
        <div
          className={cls(styles.overlay, {
            [styles.shown]: loading,
          })}
          style={design.option}
        >
          <LoaderIcon className={styles.spinner} width={36} height={36} />
        </div>
        <div className={styles.title}>
          <TextField
            dataHook={POLLS_ANSWER_TEXT_INPUT}
            maxLength={60}
            style={style.input}
            className={cls(styles.input, {
              [styles.with_result]: showResults,
            })}
            value={option.title}
            placeholder={t('Poll_Editor_Answer_Placeholder')}
            startAdornment={
              this.isImageEnabled() && (
                <ImageUpload
                  dataHook={POLLS_ANSWER_IMAGE}
                  className={styles.image}
                  value={option.image?.src.url}
                  style={style.image}
                  small
                />
              )
            }
          >
            <span
              className={styles.progress}
              style={{
                width: `${this.getVotePercentage()}%`,
              }}
            />
            {showResults && (
              <span className={styles.progress_value} data-hook={POLLS_ITEM_PERCENTAGE_PREVIEW}>
                {this.getVotePercentage()}%
              </span>
            )}
          </TextField>
        </div>
        <div
          className={styles.check}
          style={{
            color: dark ? '#000' : design.poll.background,
          }}
        >
          <CheckIcon className={styles.icon} />
        </div>
      </div>
    );
  }

  renderEditMode() {
    const { design, option, removeEnabled, t, dark } = this.props;

    const style = this.getCustomStyle();

    return (
      <div
        className={cls(styles.option, styles.list, {
          [styles.with_image]: this.isImageEnabled(),
          [styles.dark]: dark,
        })}
        style={design.option}
      >
        <div className={styles.title}>
          <TextField
            dataHook={POLLS_ANSWER_TEXT_INPUT}
            maxLength={60}
            style={style.input}
            className={styles.input}
            value={option.title}
            disabled={!this.isEditAllowed()}
            placeholder={t('Poll_Editor_Answer_Placeholder')}
            onChange={this.handleTitleChange}
            endAdornment={
              <>
                {!this.isEditAllowed() ? (
                  <Tooltip content={t('Poll_Editor_Answer_Error_NoEdit_Tooltip')}>
                    <NonEditableIcon className={styles.adornment_icon} />
                  </Tooltip>
                ) : null}
                {removeEnabled && <RemoveOption onClick={this.handleRemove} />}
              </>
            }
            startAdornment={
              this.isImageEnabled() && (
                <ImageUpload
                  dataHook={POLLS_ANSWER_IMAGE}
                  disabled={!this.isEditAllowed()}
                  className={styles.image}
                  value={option.image?.src.url}
                  onChange={this.handleImageChange}
                  style={style.image}
                  small
                />
              )
            }
          />
        </div>
      </div>
    );
  }
}
